const DailyCashClosureStatus = Object.freeze({
  PENDING_DEPOSIT_NOTE: 'PENDING_DEPOSIT_NOTE',
  PENDING_VALIDATION: 'PENDING_VALIDATION',
  VALIDATED: 'VALIDATED'
});

export default DailyCashClosureStatus;
